import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Add or update a prompt
const addOrUpdatePrompt = async (botId: string, prompt: string) => {
    const ADD_OR_UPDATE_PROMPT_ENDPOINT = `${API_URL}/addOrUpdatePrompt/${botId}`;

    try {
        const response = await axios.post(ADD_OR_UPDATE_PROMPT_ENDPOINT, { prompt });
        return response.data;
    } catch (error) {
        console.error('Error adding/updating prompt:', error);
        throw error;
    }
};

// Get existing prompt for a bot
const getPrompt = async (botId: string) => {
    const GET_PROMPT_ENDPOINT = `${API_URL}/getPrompt/${botId}`;

    try {
        const response = await axios.get(GET_PROMPT_ENDPOINT);
        return response.data?.prompt || '';
    } catch (error) {
        console.error('Error fetching prompt:', error);
        return '';
    }
};

export { addOrUpdatePrompt, getPrompt };
